import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';
import { openToast, errorToast } from '@/utils/open-toast';

function getSettings(link) {
  return axios.post(link).then((response) => {
    if (response.data.success) {
      return response;
    }

    errorToast(response.data.message);
    response.data = null;

    return response;
  });
}

export function getCategoryList() {
  return getSettings('/category/categoryList');
}

export function renameGroup(id, name) {
  return axios.post(`/category/renameGroup/?id=${id}`, { name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.categoryNameSuccessfullyUpdated'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function renameItem(id, name) {
  return axios.post(`/category/renameItem/?id=${id}`, { name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function deleteGroup(id, type) {
  return axios.post(`/category/deleteGroup/?id=${id}&type=${type}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupSuccessfullyDeleted'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function deleteItem(id) {
  return axios.post(`/category/deleteItem/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.itemSuccessfullyDeleted'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function changeGroup(id, groupId) {
  return axios.post(`/category/changeGroup/?id=${id}&groupId=${groupId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.itemSuccessfullyMoved'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function addItem(name, id, type) {
  return axios.post(`/category/addItem/?name=${name}&groupId=${id}`).then((response) => {
    if (response.data.success) {
      if (type === 1) {
        openToast(i18n.t('toast.programSuccessfullyAdded'));
      }
      if (type === 2) {
        openToast(i18n.t('toast.websiteSuccessfullyAdded'));
      }
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}
export function addItemsToGroup(list, id) {
  return axios.post('/category/addItemsToGroup', { list, id }).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function addGroup(name, type, color) {
  return axios.post(`/category/addGroup/?name=${name}&type=${type}&color=${color}`).then((response) => {
    if (response.data.success) {
      openToast(response.data.message);
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}

export function changeColor(id, color) {
  return axios.post(`/category/changeColor/?id=${id}&color=${color}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.categoryColorSuccessfullyUpdated'));
      return 'success';
    }
    errorToast(response.data.message);
    return 'error';
  });
}
